import React from 'react';
import BotanicalHero from '../components/BotanicalHero';
import {
  BestSellers,
  BotanicalWellness,
  FeaturedCategories,
  SignatureCollection,
  WhyChooseUs
} from '../sections/HomeSections';
import './HomePage.css';

function HomePage({ onAdd }) {
  return (
    <main className="home-redesign">
      <BotanicalHero />
      <FeaturedCategories />
      <SignatureCollection />
      <BestSellers onAdd={onAdd} />
      <WhyChooseUs />
      <BotanicalWellness />
    </main>
  );
}

export default HomePage;